import { CameraAttachmentsConstants } from './cameraAttachments.constants'
import { ICameraAttachmentsState } from './cameraAttachments.types'

export const initialCameraAttachmentsState: ICameraAttachmentsState = {
  image: null,
  name: '',
  category: null,
  cameraAttachments: [],
  disableCameraButton: true,
}

const MAX_CAMERA_ATTACHMENTS = 5

export const getMaximumCameraAttachments = (): number => {
  return MAX_CAMERA_ATTACHMENTS
}

export function cameraAttachmentsReducer(
  state: ICameraAttachmentsState = initialCameraAttachmentsState,
  action: any
): ICameraAttachmentsState {
  switch (action.type) {
    case CameraAttachmentsConstants.SET_IMAGE:
      return { ...state, image: action.image }
    case CameraAttachmentsConstants.SET_NAME:
      return { ...state, name: action.name }
    case CameraAttachmentsConstants.SET_CATEGORY:
      return { ...state, category: action.category }
    case CameraAttachmentsConstants.SET_CAMERA_ATTACHMENTS_LIST:
      return { ...state, cameraAttachments: action.cameraAttachments }
    case CameraAttachmentsConstants.SET_DISABLE_CAMERA_BUTTON:
      return { ...state, disableCameraButton: action.disableCameraButton }
    case CameraAttachmentsConstants.RESET_STATE:
      return {
        disableCameraButton: true,
        image: null,
        name: '',
        category: null,
        cameraAttachments: [],
      }
    default:
      return state
  }
}
